import React from 'react';
import styled from 'styled-components';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import { tc } from 'utils/theme';
import { useIsLayoutMounted } from 'utils/hooks';

const AppHeader = loadable(() => import('./AppHeader'));
const AppContent = loadable(() => import('./AppContent'));

const GridLayout = styled.div`
  transition: opacity 225ms cubic-bezier(0.4, 0, 1, 1);
  display: grid;
  grid-template-rows: 100px 1fr;
  grid-template-columns: 1fr;
  min-height: 100vh;
  margin: 0;
  background-color: ${tc('backgroundColor')};
`;

const LayoutApp = ({ children }) => {
  const isLayoutMounted = useIsLayoutMounted();

  return (
    <GridLayout style={{ opacity: isLayoutMounted ? 1 : 0 }}>
      <AppHeader />
      <AppContent>{children}</AppContent>
    </GridLayout>
  );
};

LayoutApp.propTypes = {
  children: PropTypes.node.isRequired,
};

export default LayoutApp;
